const generateTreeNodeFromPath = (parts, attachment) => {
  const root = {
    id: `${parts.slice(0, 1).join('-')}-0`,
    node: true,
    name: parts[0],
    children: [],
    parents: []
  };
  let current = root;
  for (let i = 1; i < parts.length; i++) {
    if (attachment && i === parts.length - 1) {
      current.children.push(attachment);
    } else {
      const newNode = {
        id: `${parts.slice(0, i + 1).join('-')}-${i}`,
        node: true,
        name: parts[i],
        children: [],
        parents: [...current.parents, {
          name: current.name,
          id: current.id
        }]
      };
      current.children.push(newNode);
      current = newNode;
    }
  }
  return root;
};
const splitFilepathIntoTree = attachment => {
  // TODO: maybe look into swapping these nodes for Map's instead? Better performance for large data
  const internal_path = attachment.internal_path !== '' ? attachment.internal_path : null;
  if (!internal_path) {
    return attachment;
  }
  const parts = attachment.internal_path.split('/').concat([attachment.filename]);
  return generateTreeNodeFromPath(parts, attachment);
};
const combineBranches = (treeNode, node) => {
  const foundChild = treeNode.find(child => {
    return child.id === node.id;
  });
  if (!foundChild) {
    // node is an Attachment or TreeNode that isn't in the tree.
    if (!treeNode.includes(node)) {
      treeNode.push(node);
    }
  } else {
    if ('node' in foundChild) {
      // child is a TreeNode. Check if the node.name is the same as the child.
      if ('filename' in node) {
        // Node is an Attachment. Append to children
        if (!foundChild.children.includes(node)) {
          foundChild.children.push(node);
        }
        return;
      }
      for (const childNode of node.children) {
        combineBranches(foundChild.children, childNode);
      }
    }
  }
};
const findFolderById = (treeNode, id) => {
  for (const node of treeNode) {
    if ('filename' in node) {
      continue;
    }
    if (node.id === id) {
      return node;
    }
    if (node.children.length > 0) {
      const found = findFolderById(node.children, id);
      if (found) {
        return found;
      }
    }
  }
};
const getAllAttachmentChildren = node => {
  if ('children' in node) {
    return node.children.map(child => {
      if ('children' in child) {
        return getAllAttachmentChildren(child);
      } else {
        return child;
      }
    }).flat();
  } else {
    return [];
  }
};
const matchingFileExists = (tree, filepath, filename) => {
  const fileFolderId = filepath.join('-') + `-${filepath.length - 1}`;
  const folder = findFolderById(tree, fileFolderId);
  if (folder) {
    if (folder.children && folder.children.length > 0) {
      return folder.children.filter(child => child.filename && child.filename === filename).length > 0;
    } else {
      return false;
    }
  }

  // No folder means we're in the root directory ('home')

  const parentFiles = tree.filter(node => 'filename' in node).map(file => 'filename' in file && file.filename);
  if (parentFiles.includes(filename)) {
    return true;
  }
  return false;
};
export { splitFilepathIntoTree, combineBranches, findFolderById, generateTreeNodeFromPath, getAllAttachmentChildren, matchingFileExists };